<template>
    <!--  BEGIN SIDEBAR  -->
    <div class="sidebar-wrapper sidebar-theme">
        <nav ref="menu" id="sidebar">
            <perfect-scrollbar
                class="list-unstyled menu-categories"
                tag="ul"
                :options="{
                    wheelSpeed: 0.5,
                    swipeEasing: !0,
                    minScrollbarLength: 40,
                    maxScrollbarLength: 300,
                    suppressScrollX: true,
                }"
            >
                <li class="menu">
                    <router-link tag="li" to="/home" class="menu" @click.native="toggleMobileMenu">
                        <a class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-home"
                                >
                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                                </svg>
                                <span>Dashboard</span>
                            </div>
                        </a>
                    </router-link>
                </li>

                <router-link tag="li" to="/check-in" class="menu" @click.native="toggleMobileMenu">
                    <a class="dropdown-toggle">
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-user-check"
                            >
                                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                <circle cx="8.5" cy="7" r="4" />
                                <polyline points="17 11 19 13 23 9" />
                            </svg>

                            <span>Check In</span>
                        </div>
                    </a>
                </router-link>
                <li class="menu">
                    <a href="#new-book" v-b-toggle class="dropdown-toggle" @click.prevent>
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-calendar"
                            >
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                <line x1="16" y1="2" x2="16" y2="6" />
                                <line x1="8" y1="2" x2="8" y2="6" />
                                <line x1="3" y1="10" x2="21" y2="10" />
                            </svg>
                            <span>Book Now</span>
                        </div>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-right"
                            >
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>
                    <b-collapse id="new-book" accordion="menu">
                        <ul class="collapse submenu list-unstyled show">
                            <router-link tag="li" v-if="modulesArray && modulesArray.includes('class')" to="/class-booking" @click.native="toggleMobileMenu">
                                <a>Classes / PT </a>
                            </router-link>

                            <router-link v-if="modulesArray && modulesArray.includes('venue')" tag="li" to="/venuebooking" @click.native="toggleMobileMenu"><a> Venues </a> </router-link>
                            <router-link v-if="modulesArray && modulesArray.includes('pool')" tag="li" to="/poolbooking" @click.native="toggleMobileMenu"><a> Pool </a> </router-link>

                            <router-link v-if="modulesArray && modulesArray.includes('course')" tag="li" to="/course-booking" @click.native="toggleMobileMenu">
                                <a>Courses</a>
                            </router-link>

                            <router-link v-if="modulesArray && modulesArray.includes('membership')" tag="li" to="/buy-membership" @click.native="toggleMobileMenu">
                                <a>Membership</a>
                            </router-link>
                        </ul>
                    </b-collapse>
                </li>

                <router-link tag="li" to="/pos" class="menu" @click.native="toggleMobileMenu" v-if="modulesArray && modulesArray.includes('pos')">
                    <a class="dropdown-toggle">
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-shopping-bag"
                            >
                                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                <line x1="3" y1="6" x2="21" y2="6" />
                                <path d="M16 10a4 4 0 0 1-8 0" />
                            </svg>
                            <span>POS</span>
                        </div>
                    </a>
                </router-link>

                <router-link tag="li" to="/upcomming-booking" class="menu" @click.native="toggleMobileMenu">
                    <a class="dropdown-toggle">
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-shopping-bag"
                            >
                                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                <line x1="3" y1="6" x2="21" y2="6" />
                                <path d="M16 10a4 4 0 0 1-8 0" />
                            </svg>
                            <span>Bookings</span>
                        </div>
                    </a>
                </router-link>
                <li class="menu">
                    <a href="#course-hi" v-b-toggle class="dropdown-toggle" @click.prevent>
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-list"
                            >
                                <line x1="8" y1="6" x2="21" y2="6" />
                                <line x1="8" y1="12" x2="21" y2="12" />
                                <line x1="8" y1="18" x2="21" y2="18" />
                                <line x1="3" y1="6" x2="3.01" y2="6" />
                                <line x1="3" y1="12" x2="3.01" y2="12" />
                                <line x1="3" y1="18" x2="3.01" y2="18" />
                            </svg>
                            <span>Courses</span>
                        </div>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-right"
                            >
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>
                    <b-collapse id="course-hi" accordion="menu">
                        <ul class="collapse submenu list-unstyled show">
                            <router-link tag="li" v-if="user && user.user_type == 'admin' && modulesArray && modulesArray.includes('course')" to="/course-master" @click.native="toggleMobileMenu">
                                <a> Manage Course </a>
                            </router-link>
                            <router-link tag="li" to="/booked-courses" v-if="modulesArray && modulesArray.includes('course')" @click.native="toggleMobileMenu"><a>Booked Course</a> </router-link>
                            <router-link tag="li" to="/archive_course_list" v-if="modulesArray && modulesArray.includes('course')" @click.native="toggleMobileMenu"><a>Archive Course</a> </router-link>
                            <router-link tag="li" to="/course_attendees_list" v-if="modulesArray && modulesArray.includes('course')" @click.native="toggleMobileMenu"
                                ><a>Course Attendees</a>
                            </router-link>
                        </ul>
                    </b-collapse>
                </li>
                <router-link tag="li" to="/customers" class="menu" @click.native="toggleMobileMenu">
                    <a class="dropdown-toggle">
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-user-plus"
                            >
                                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                <circle cx="8.5" cy="7" r="4" />
                                <line x1="20" y1="8" x2="20" y2="14" />
                                <line x1="23" y1="11" x2="17" y2="11" />
                            </svg>
                            <span>Customers</span>
                        </div>
                    </a>
                </router-link>
                <!-- <router-link tag="li" to="/poolbookinglist" class="menu" @click.native="toggleMobileMenu">
                    <a class="dropdown-toggle">
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-shopping-bag"
                            >
                                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                <line x1="3" y1="6" x2="21" y2="6" />
                                <path d="M16 10a4 4 0 0 1-8 0" />
                            </svg>
                            <span>Pool Booking List</span>
                        </div>
                    </a>
                </router-link> -->
                <router-link tag="li" to="/pool_batch_booking" class="menu" @click.native="toggleMobileMenu">
                    <a class="dropdown-toggle">
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-shopping-bag"
                            >
                                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                <line x1="3" y1="6" x2="21" y2="6" />
                                <path d="M16 10a4 4 0 0 1-8 0" />
                            </svg>
                            <span>Pool Batch Booking</span>
                        </div>
                    </a>
                </router-link>
                <router-link tag="li" to="/Class_Booking_list" class="menu" @click.native="toggleMobileMenu">
                    <a class="dropdown-toggle">
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-shopping-bag"
                            >
                                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                <line x1="3" y1="6" x2="21" y2="6" />
                                <path d="M16 10a4 4 0 0 1-8 0" />
                            </svg>
                            <span>Upcoming Bookings</span>
                        </div>
                    </a>
                </router-link>
                <!-- <router-link tag="li" to="/subscriptions" class="menu" @click.native="toggleMobileMenu">
          <a class="dropdown-toggle">
            <div class="">
              <b-icon icon="credit-card-fill" />
              <span>Subscription</span>
            </div>
          </a>
        </router-link> -->
                <li class="menu">
                    <a href="#packages" v-b-toggle class="dropdown-toggle" @click.prevent>
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-users"
                            >
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                            </svg>
                            <span>Membership</span>
                        </div>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-right"
                            >
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>
                    <b-collapse id="packages" accordion="menu">
                        <ul class="collapse submenu list-unstyled show">
                            <router-link v-if="user && user.user_type == 'admin' && modulesArray && modulesArray.includes('membership')" tag="li" to="/packages" @click.native="toggleMobileMenu"
                                ><a>Membership Type</a>
                            </router-link>

                            <router-link v-if="modulesArray && modulesArray.includes('membership')" tag="li" to="/active-membership" @click.native="toggleMobileMenu">
                                <a>Purchased Membership</a></router-link
                            >
                        </ul>
                    </b-collapse>
                </li>
                <li class="menu" v-if="user && user.user_type == 'admin'">
                    <a href="#smasters" v-b-toggle class="dropdown-toggle" @click.prevent>
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-tool"
                            >
                                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
                            </svg>
                            <span>Service Setup</span>
                        </div>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-right"
                            >
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>
                    <b-collapse id="smasters" accordion="menu">
                        <ul class="collapse submenu list-unstyled show">
                            <!-- <router-link tag="li" to="/service-master" @click.native="toggleMobileMenu"><a>Manage
                                    Services</a> </router-link>
                            <router-link tag="li" to="/service-sessions" @click.native="toggleMobileMenu">
                                <a>Manage Sessions</a> </router-link> -->
                            <!-- <router-link tag="li" to="/course-master" @click.native="toggleMobileMenu"><a>Manage Courses </a> </router-link> -->
                            <router-link v-if="modulesArray && modulesArray.includes('class')" tag="li" to="/class-master" @click.native="toggleMobileMenu"><a>Manage Classes </a> </router-link>
                            <router-link v-if="modulesArray && modulesArray.includes('pt')" tag="li" to="/pt-master" @click.native="toggleMobileMenu"><a>Manage PT </a> </router-link>
                            <router-link v-if="modulesArray && modulesArray.includes('payg')" tag="li" to="/pay-as-you-go" @click.native="toggleMobileMenu"><a>Manage PAYG </a> </router-link>
                            <router-link v-if="modulesArray && modulesArray.includes('pool')" tag="li" to="/pool" @click.native="toggleMobileMenu"><a>Manage Pool </a> </router-link>
                            <router-link v-if="modulesArray && modulesArray.includes('venue')" tag="li" to="/venues" @click.native="toggleMobileMenu"><a>Manage Venues </a> </router-link>
                        </ul>
                    </b-collapse>
                </li>

                <li class="menu" v-if="user && user.user_type == 'admin'">
                    <a href="#store" v-b-toggle class="dropdown-toggle" @click.prevent>
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-shop" viewBox="0 0 16 16">
                                <path
                                    d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zM4 15h3v-5H4v5zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3zm3 0h-2v3h2v-3z"
                                />
                            </svg>
                            <span>Store</span>
                        </div>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-right"
                            >
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>
                    <b-collapse id="store" accordion="menu">
                        <ul class="collapse submenu list-unstyled show">
                            <router-link tag="li" to="/purchase" @click.native="toggleMobileMenu"><a>Stock Entry</a> </router-link>
                            <router-link tag="li" to="/current-stock" @click.native="toggleMobileMenu"><a>Current Stock</a> </router-link>
                            <router-link tag="li" to="/store-audit" @click.native="toggleMobileMenu"><a>Stock Audit</a> </router-link>
                        </ul>
                    </b-collapse>
                </li>

                <!-- <router-link v-if="user && user.user_type == 'admin'" tag="li" to="/voucher" class="menu" @click.native="toggleMobileMenu">
                    <a class="dropdown-toggle">
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-clipboard"
                            >
                                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                                <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
                            </svg>
                            <span>Vouchers</span>
                        </div>
                    </a>
                </router-link> -->
                <li class="menu">
                    <a href="#Voucher-hi" v-b-toggle class="dropdown-toggle" @click.prevent>
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-clipboard"
                            >
                                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                                <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
                            </svg>
                            <span>Vouchers</span>
                        </div>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-right"
                            >
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>
                    <b-collapse id="Voucher-hi" accordion="menu">
                        <ul class="collapse submenu list-unstyled show">
                            <router-link v-if="user && user.user_type == 'admin'" tag="li" to="/voucher" class="menu" @click.native="toggleMobileMenu">
                                <a> Offer Vouchers </a>
                            </router-link>
                            <router-link tag="li" to="/credit_voucher_list" @click.native="toggleMobileMenu"><a>Credit Note Vouchers</a> </router-link>
                        </ul>
                    </b-collapse>
                </li>
                <li class="menu" v-if="user && user.user_type == 'admin'">
                    <a href="#users" v-b-toggle class="dropdown-toggle" @click.prevent>
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-users"
                            >
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                            </svg>
                            <span>Manage Staff</span>
                        </div>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-right"
                            >
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>
                    <b-collapse id="users" accordion="menu">
                        <ul class="collapse submenu list-unstyled show">
                            <router-link tag="li" to="/users" @click.native="toggleMobileMenu"><a>Staff List</a> </router-link>
                        </ul>
                    </b-collapse>
                </li>

                <li class="menu" v-if="user && user.user_type == 'admin'">
                    <a href="#settings" v-b-toggle class="dropdown-toggle" @click.prevent>
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-settings"
                            >
                                <circle cx="12" cy="12" r="3" />
                                <path
                                    d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                                />
                            </svg>
                            <span>Settings</span>
                        </div>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-right"
                            >
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>
                    <b-collapse id="settings" accordion="menu">
                        <ul class="collapse submenu list-unstyled show">
                            <router-link tag="li" v-if="modulesArray && modulesArray.includes('pos')" to="/products" @click.native="toggleMobileMenu"><a>Products</a> </router-link>
                            <router-link tag="li" v-if="modulesArray && modulesArray.includes('pos')" to="/category" @click.native="toggleMobileMenu"><a>Category</a> </router-link>
                            <router-link tag="li" to="/app-settings" @click.native="toggleMobileMenu"> <a>Application Settings</a></router-link>
                            <!--<router-link
                                tag="li"
                                to="/authipay-settings"
                                @click.native="toggleMobileMenu"
                            >
                                <a>Stripe Settings</a></router-link
                            >-->
                            <router-link tag="li" to="/email-template" @click.native="toggleMobileMenu"><a>Email Notifications</a> </router-link>
                            <router-link tag="li" to="/widget-settings" @click.native="toggleMobileMenu"><a>Widget Settings</a> </router-link>
                            <router-link tag="li" to="/service_announcement" @click.native="toggleMobileMenu"><a>Service Announcement</a> </router-link>
                            <router-link tag="li" to="/banner" @click.native="toggleMobileMenu"><a>Banner</a> </router-link>
                            <router-link tag="li" to="/faq" @click.native="toggleMobileMenu"><a>FAQ</a> </router-link>
                        </ul>
                    </b-collapse>
                </li>

                <li class="menu">
                    <a href="#reports" v-b-toggle class="dropdown-toggle" @click.prevent>
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-pie-chart"
                            >
                                <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
                                <path d="M22 12A10 10 0 0 0 12 2v10z" />
                            </svg>
                            <span>Reports</span>
                        </div>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-right"
                            >
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>
                    <b-collapse id="reports" accordion="menu">
                        <ul class="collapse submenu list-unstyled show">
                            <router-link tag="li" to="/x-report" @click.native="toggleMobileMenu"><a>Day End Report</a> </router-link>
                            <router-link tag="li" to="/reports" @click.native="toggleMobileMenu"><a>Payments</a> </router-link>
                            <!-- <router-link tag="li" to="/refund_report" @click.native="toggleMobileMenu"><a>Refund Report</a> </router-link> -->
                            <router-link tag="li" to="/credit_refund" @click.native="toggleMobileMenu"><a>Credit Note Refund</a> </router-link>
                            <router-link tag="li" to="/coursesales" @click.native="toggleMobileMenu"><a>Course Sales</a> </router-link>
                            <router-link tag="li" to="/poolsales" @click.native="toggleMobileMenu"><a>Pool Sales</a> </router-link>
                            <router-link tag="li" to="/venuesales" @click.native="toggleMobileMenu"><a>Venue Sales</a> </router-link>
                            <router-link tag="li" to="/classsales" @click.native="toggleMobileMenu"><a>Class Sales</a> </router-link>
                            <router-link tag="li" to="/membershipsales" @click.native="toggleMobileMenu"><a>Membership Sales</a> </router-link>
                            <router-link tag="li" to="/retailsales" @click.native="toggleMobileMenu"><a>Retail Sales</a> </router-link>
                            <router-link tag="li" to="/paylater" @click.native="toggleMobileMenu"><a>Pay Later Report</a> </router-link>
                            <router-link tag="li" to="/checkinreport" @click.native="toggleMobileMenu"><a>Check-In Report</a> </router-link>
                            <router-link tag="li" :to="`/CustomerCheckIn/${selectedDate}`" @click.native="toggleMobileMenu"><a>Customer CheckIn</a> </router-link>
                            <router-link tag="li" to="/revenue_report" @click.native="toggleMobileMenu"><a>Revenue Report</a> </router-link>
                            <router-link tag="li" to="/stock_report" @click.native="toggleMobileMenu"><a>Stock Report</a> </router-link>
                            <router-link tag="li" to="/vat_report" @click.native="toggleMobileMenu"><a>Vat Report</a> </router-link>
                            <router-link tag="li" to="/auto_subscription_report" @click.native="toggleMobileMenu"><a>Auto Subscription Report</a> </router-link>
                            <router-link tag="li" to="/cashsheet_report" @click.native="toggleMobileMenu"><a>Cashsheet Report</a> </router-link>
                            <router-link tag="li" to="/category_report" @click.native="toggleMobileMenu"><a>Category Report</a> </router-link>
                            <router-link tag="li" to="/audit_report" @click.native="toggleMobileMenu"><a>Audit Report</a> </router-link>
                            <router-link tag="li" to="/deferred_income" @click.native="toggleMobileMenu"><a>Deferred Income</a> </router-link>
                            <router-link tag="li" to="/deferred_income_course" @click.native="toggleMobileMenu"><a>Deferred Income Course</a> </router-link>
                            <router-link tag="li" to="/cancellation_&_refund" @click.native="toggleMobileMenu"><a>Cancellation & Refund Report</a> </router-link>
                            <router-link tag="li" to="/membership_report" @click.native="toggleMobileMenu"><a>Membership Report</a> </router-link>
                            <router-link tag="li" to="/course_transfer_report" @click.native="toggleMobileMenu"><a>Course Transfer Report</a> </router-link>
                            <!-- <router-link tag="li" to="/category_paymode_report" @click.native="toggleMobileMenu"><a>Category - Paymode Report</a> </router-link> -->
                        </ul>
                    </b-collapse>
                </li>

                <router-link tag="li" to="/coming-soon" class="menu d-none" @click.native="toggleMobileMenu">
                    <a class="dropdown-toggle">
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-help-circle"
                            >
                                <circle cx="12" cy="12" r="10" />
                                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                                <line x1="12" y1="17" x2="12.01" y2="17" />
                            </svg>
                            <span>Helpdesk</span>
                        </div>
                    </a>
                </router-link>
                <router-link tag="li" to="/clover-device-list" class="menu" @click.native="toggleMobileMenu">
                    <a class="dropdown-toggle">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                                <path
                                    d="M374.4 80C410.6 80 440 109.4 440 145.7L440 150.9C440 162.1 437.3 173.2 432.2 183.1L429.9 187.3L409.8 220.8C408.7 222.7 408.6 224.2 408.7 225.3C408.9 226.6 409.6 228 410.8 229.2C412 230.4 413.4 231.1 414.7 231.3C415.8 231.5 417.3 231.4 419.2 230.2L452.7 210.1L456.9 207.8C466.9 202.7 477.9 200 489.1 200L494.3 200C530.5 200 559.9 229.4 559.9 265.7C559.9 283.1 553 299.8 540.7 312.1L539.4 313.4C535.7 317.1 535.7 323 539.4 326.7L540.7 328C553 340.3 559.9 357 559.9 374.4C559.9 410.6 530.5 440 494.3 440L489.1 440C476.3 440 463.6 436.5 452.6 429.9L419.1 409.8C417.2 408.7 415.7 408.6 414.6 408.7C413.3 408.9 411.9 409.6 410.7 410.8C409.5 412 408.8 413.4 408.6 414.7C408.4 415.8 408.5 417.3 409.7 419.2L429.8 452.7C436.4 463.7 439.9 476.3 439.9 489.2L439.9 494.4C439.9 530.6 410.5 560 374.3 560C356.9 560 340.2 553.1 327.9 540.8L326.6 539.5C322.9 535.8 317 535.8 313.3 539.5L312 540.8C299.7 553.1 283 560 265.6 560C229.4 560 200 530.6 199.9 494.4L199.9 489.2C199.9 476.4 203.4 463.7 210 452.7L230.1 419.2C231.2 417.3 231.3 415.8 231.2 414.7C231 413.4 230.3 412 229.1 410.8C227.9 409.6 226.5 408.9 225.2 408.7C224.7 408.6 224 408.6 223.3 408.7L220.8 409.7L187.3 429.8C176.3 436.4 163.7 439.9 150.8 439.9L145.6 439.9C109.4 440 80 410.6 80 374.4C80 357 86.9 340.3 99.2 328L100.5 326.7L101.7 325.2C103.8 322.1 103.8 318 101.7 314.9L100.5 313.4L99.2 312.1C86.9 299.8 80 283.1 80 265.7C80 229.4 109.4 200 145.7 200L150.9 200C163.7 200 176.4 203.5 187.4 210.1L220.9 230.2L223.4 231.2C224.1 231.3 224.8 231.3 225.3 231.3C226.6 231.1 228 230.4 229.2 229.2C230.4 228 231.1 226.6 231.3 225.3C231.4 224.8 231.4 224.1 231.2 223.4L230.2 220.9L210.1 187.4C203.5 176.4 200 163.8 200 150.9L200 145.7C200 109.5 229.4 80 265.7 80C283.1 80 299.8 86.9 312.1 99.2L313.4 100.5C317.1 104.1 323 104.2 326.7 100.5L328 99.2L332.8 94.8C344.5 85.3 359.1 80 374.4 80z"
                                />
                            </svg>
                            <span>Clover Device List</span>
                        </div>
                    </a>
                </router-link>
                <!-- <router-link
                    tag="li"
                    to="/clover-device"
                    class="menu"
                    @click.native="toggleMobileMenu"
                >
                    <a class="dropdown-toggle">
                        <div class="">
                            <svg
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                stroke="currentColor"
                                stroke-width="2"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-smartphone"
                            >
                                <rect
                                    x="5"
                                    y="2"
                                    width="14"
                                    height="20"
                                    rx="2"
                                    ry="2"
                                ></rect>
                                <line x1="12" y1="18" x2="12.01" y2="18"></line>
                            </svg>
                            <span>Clover Device</span>
                        </div>
                    </a>
                </router-link> -->
                <router-link tag="li" to="#" class="menu" @click.native="toggleMobileMenu">
                    <a class="dropdown-toggle" @click.prevent="logout">
                        <div class="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-log-out"
                            >
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                <polyline points="16 17 21 12 16 7" />
                                <line x1="21" y1="12" x2="9" y2="12" />
                            </svg>
                            <span>Logout</span>
                        </div>
                    </a>
                </router-link>
                <!--</ul>-->
            </perfect-scrollbar>
        </nav>
    </div>
    <!--  END SIDEBAR  -->
</template>
<script>
    import axios from 'axios';
    import { mapGetters } from 'vuex';
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
    axios.defaults.headers.common['Content-Type'] = 'multipart/form-data';
    export default {
        data() {
            return {
                menu_collapse: 'dashboard',
                modules: [],
                modulesArray: [],
                centerId: null,
                Center_Id: null,
                selectedDate: '',
            };
        },

        // watch: {
        //     $route(to) {
        //         if (to) {
        //             const selector = document.querySelector('#sidebar a[href="' + to.path + '"]');
        //             const ul = selector.closest('ul.collapse');
        //             if (!ul) {
        //                 const ele = document.querySelector('.dropdown-toggle.not-collapsed');
        //                 if (ele) {
        //                     ele.click();
        //                 }
        //             }
        //         }
        //     }
        // },
        created() {
            var now = new Date();
            var day = ('0' + now.getDate()).slice(-2);
            var month = ('0' + (now.getMonth() + 1)).slice(-2);
            var today = now.getFullYear() + '-' + month + '-' + day;
            this.selectedDate = today;
            // console.log('center details::::::::::::', this.center, this.center.id, this.$store.state.center.id);
            const getSelectedCenterIdFromCookie = () => {
                const cookies = document.cookie.split('; ');
                const selectedCenterCookie = cookies.find((cookie) => cookie.startsWith('selected_center='));

                if (!selectedCenterCookie) return null;

                const encodedValue = selectedCenterCookie.split('=')[1];
                const decodedValue = decodeURIComponent(encodedValue);

                try {
                    const selectedCenter = JSON.parse(decodedValue);
                    return selectedCenter.id;
                } catch (e) {
                    console.error('Error parsing selected_center cookie:', e);
                    return null;
                }
            };

            const centerId = getSelectedCenterIdFromCookie();

            if (centerId) {
                axios
                    .get('publicGetCenterDetails/' + centerId)
                    .then((res) => {
                        if (res.data.error) {
                            console.log(res);
                        } else {
                            this.$store.dispatch('center', res.data.data);
                            console.log(res.data.data.id);
                            this.getcentermodules(res.data.data.id);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                this.getcentermodules(centerId);
            }
        },
        mounted() {
            const selector = document.querySelector('#sidebar a[href="' + window.location.pathname + '"]');
            if (selector) {
                const ul = selector.closest('ul.collapse');
                if (ul) {
                    let ele = ul.closest('li.menu').querySelectorAll('.dropdown-toggle');
                    if (ele) {
                        ele = ele[0];
                        setTimeout(() => {
                            ele.click();
                        });
                    }
                } else {
                    selector.click();
                }
            }
        },

        methods: {
            getcentermodules() {
                const getSelectedCenterIdFromCookie = () => {
                    const cookies = document.cookie.split('; ');
                    const selectedCenterCookie = cookies.find((cookie) => cookie.startsWith('selected_center='));

                    if (!selectedCenterCookie) return null;

                    const encodedValue = selectedCenterCookie.split('=')[1];
                    const decodedValue = decodeURIComponent(encodedValue);

                    try {
                        const selectedCenter = JSON.parse(decodedValue);
                        return selectedCenter.id;
                    } catch (e) {
                        console.error('Error parsing selected_center cookie:', e);
                        return null;
                    }
                };

                const centerId = getSelectedCenterIdFromCookie();

                axios
                    .get('publicGetCenterDetails/' + centerId)
                    .then((res) => {
                        if (res.data.error) {
                            console.log(res);
                        } else {
                            this.modules = res.data.data.modules;
                            try {
                                if (this.modules) {
                                    this.modulesArray = JSON.parse(this.modules);
                                    this.$store.dispatch('setModulesArray', this.modulesArray);
                                }
                            } catch (error) {
                                console.error('Error parsing modules:', error);
                            }
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },

            isNameAvailable(name) {
                const modulesArray = this.$store.state.modulesArray;
                return modulesArray && modulesArray.includes(name);
            },
            toggleMobileMenu() {
                if (window.innerWidth < 991) {
                    this.$store.commit('toggleSideBar', !this.$store.state.is_show_sidebar);
                }
            },
            logout() {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

                axios
                    .get('logout')
                    .then((res) => {
                        if (res.data.error) {
                            this.$router.push('/login').catch(() => {
                                window.location.href = '/login';
                            });
                        } else {
                            window.location.href = '/login';
                        }
                    })
                    .catch(() => {
                        window.location.href = '/login';
                    });

                localStorage.removeItem('token');
                this.$store.dispatch('user', null);
                this.$store.state.cloverConnector?.dispose?.(); // Add optional chaining to avoid errors
            },
        },
        computed: {
            ...mapGetters(['center']),
            ...mapGetters(['user']),
        },
    };
</script>
<style>
    nav#sidebar {
        margin-top: 0.5rem;
    }
</style>
